<circ-general-error [messages]="error">

